<template>
  <router-link
    :to="'/services/' + item.id"
    :target="is_mobile ? '_self' :  '_blank'">
    <img
      :src="base_url + item.image"
      alt=""
      width="100%"
      class="card-img-top">
    <div class="card-body">
      <h5 class="card-title">{{ item.name }}</h5>
    </div>
  </router-link>
</template>

<script>
  import ApiConfig from '../../communicate/ApiConfig'
  import mobileDetector from '../../utils/DeviceDetector'

  export default {
    name: "ServiceItem",
    // eslint-disable-next-line vue/require-prop-types
    props: ["item"],
    data () {
      return {
        is_mobile: true,
        base_url: ApiConfig.base_url
      }
    },
    mounted() {
      this.is_mobile = mobileDetector();
    },
    methods: {

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/service/ServiceItem.vue